import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet-async'
import ColumnLeftFlashcardsStudy from 'modules/flashcardsStudy/ColumnLeftFlashcardsStudy'
import ColumnRightFlashcardsStudy from 'modules/flashcardsStudy/ColumnRightFlashcardsStudy'
import styled from 'styled-components'
import QueryListenerFlashcardsStudy from 'modules/flashcardsStudy/QueryListenerFlashcardsStudy'
import HeaderFlashcardsStudy from 'modules/flashcardsStudy/HeaderFlashcardsStudy'
import { BouncingLoader } from 'examkrackers-components'

export const FlashcardsStudy = (): JSX.Element => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setTimeout(() => setIsLoading(false), 1500)
  }, [])

  return (
    <React.Fragment>
      <Helmet>
        <title>{t('pages.flashcards.study')}</title>
      </Helmet>
      <QueryListenerFlashcardsStudy />
      <>
        {isLoading && (
          <LoaderContainer>
            <BouncingLoader />
          </LoaderContainer>
        )}
      </>
      <Wrapper>
        <HeaderFlashcardsStudy />
        <ContentWrapper>
          <ColumnLeftFlashcardsStudy />
          <ColumnRightFlashcardsStudy />
        </ContentWrapper>
      </Wrapper>
    </React.Fragment>
  )
}

export default FlashcardsStudy

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: ${({ theme }) =>
    `calc(100vh - 8px - ${theme.dimensions.studentTopNavHeightMenu} - ${theme.dimensions.footerHeight})`};
`

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const LoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
